export function useModal(type){
	let fields = {
		to_currency:'to_currency',
		to_rate:'to_rate',
		to_rate_cny:'to_rate_cny',
		to_rate_sar:'to_rate_sar',
		to_rate_aed:'to_rate_aed',
		to_rate_qar:'to_rate_qar',
		to_rate_kwd:'to_rate_kwd',
	}
	if(type == 'b2b_details_hq'){
		fields = {
			to_currency:'target_currency',
			to_rate:'USD',
			to_rate_cny:'CNY',
			to_rate_sar:'SAR',
			to_rate_aed:'AED',
			to_rate_qar:'QAR',
			to_rate_kwd:'KWD',
		}
	}
	if(type == 'codRefund'){
		let temp = ['cny','usd','aed','sar','kwd','bhd','omr','qar','iqd','ils','jod']
		fields = {to_currency:'currency',usd_to_cny_rate:'usd_to_cny_rate'}
		temp.forEach(t=>{
			fields[t == 'usd'?'to_rate':'to_rate_'+t] = t+'_to_rate'
		})
	}
	let grid = [{},{}]
	let rules = {}
	Object.values(fields).map((t,i)=>{
		if(i == 0)rules[t] = [
			{
				required: true,
				message: "cannot be empty",
				trigger: "blur",
			},
		]
		if(i === 0 && type === 'codRefund'){
			grid[0]['selplan'] = 24
			grid[0].show = function(){
				return this.$modal.params.v != 1
			}
			grid[1][t] = 12
		}else{
			grid[1][t] = type === 'codRefund'?12:24
		}
	})
	return {
		methods: {
			ok({ row, close }) {
				this.$page
					.handleRequestMethods(row.fn || "b2bReStatistics", row)
					.then((res) => {
						this.$Message["success"]({
							background: true,
							content: res.msg,
						});
						this.$page.getList();
						close();
					});
			},
		},
		config: {
			modalBind: {
				width: 600,
				draggable: true,
			},
			formBind: {
				labelWidth: 120,
			},
			rowBind: {
			  gutter: 16,
			},
			colBind:{
				style: {
				  marginBottom: "20px"
				}
			},
			rules,
		},
		grid: grid,
		fields: [
			{
				name: this.$t("toCurrency"),
				key: fields["to_currency"],
				component: "Select",
				placeholder: () => this.$t("select") + this.$t("toCurrency"),
				options: [],
				config:{
					label:'value',
					value:'key'
				},
				methods:{
					list({field,row}){
						field.options = this.$page.currency || []
						setTimeout(() => {
							field.options.forEach(t=>{
								if(t.key === this.formData[fields['to_currency']])this.to_currency = t.value
							})
							this.$forceUpdate()
						}, 0);
						
					},
					'on-change'({field,value}){
						field.options.forEach(t=>{
							if(t.key === value)this.$form.to_currency = t.value
						})
					}
				}
			},
			{
				name(){
					return this.$t("to_usd") +
					this.$t("turn") +
					this.$t("to_cny") +
					this.$t("rate")
				},
				key: fields["usd_to_cny_rate"],
				component: "InputNumber",
				bind: {
					min: 0,
					step: 0.0001,
					style: "width:100%",
				},
				default: 0,
				placeholder: 'Please Enter',
				show(){
					return type == 'codRefund'?this.$modal.params.v == 2:true
				},
			},
			{
				name(){
					return this.$t("to_usd") +
					this.$t("turn") +
					(this.$form?(this.$i18n.locale === 'zh-CN'?'':' ')+(this.$form.to_currency || ''):'')+
					this.$t("rate")
				},
				key: fields["to_rate"],
				component: "InputNumber",
				bind: {
					min: 0,
					step: 0.0001,
					style: "width:100%",
				},
				default: 0,
				placeholder: 'Please Enter',
				show(){
					return type == 'codRefund'?this.$modal.params.v == 2:true
				},
			},
			{
				name(){
					return this.$t("to_cny") +
					this.$t("turn") +
					(this.$form?(this.$i18n.locale === 'zh-CN'?'':' ')+(this.$form.to_currency || ''):'')+
					this.$t("rate")
				},
				key: fields["to_rate_cny"],
				component: "InputNumber",
				bind: {
					min: 0,
					step: 0.0001,
					style: "width:100%",
				},
				show(){
					return type == 'codRefund'?this.$modal.params.v == 2:true
				},
				default: 0,
				placeholder: 'Please Enter',
			},
			{
				name(){
					return this.$t("to_sar") +
					this.$t("turn") +
					(this.$form?(this.$i18n.locale === 'zh-CN'?'':' ')+(this.$form.to_currency || ''):'')+
					this.$t("rate")
				},
				key: fields["to_rate_sar"],
				component: "InputNumber",
				bind: {
					min: 0,
					step: 0.0001,
					style: "width:100%",
				},
				default: 0,
				placeholder: 'Please Enter',
			},
			{
				name(){
					return this.$t("to_aed") +
					this.$t("turn") +
					(this.$form?(this.$i18n.locale === 'zh-CN'?'':' ')+(this.$form.to_currency || ''):'')+
					this.$t("rate")
				},
				key: fields["to_rate_aed"],
				component: "InputNumber",
				bind: {
					min: 0,
					step: 0.0001,
					style: "width:100%",
				},
				default: 0,
				placeholder: 'Please Enter',
			},
			{
				name(){
					return this.$t("to_qar") +
					this.$t("turn") +
					(this.$form?(this.$i18n.locale === 'zh-CN'?'':' ')+(this.$form.to_currency || ''):'')+
					this.$t("rate")
				},
				key: fields["to_rate_qar"],
				component: "InputNumber",
				bind: {
					min: 0,
					step: 0.0001,
					style: "width:100%",
				},
				default: 0,
				placeholder: 'Please Enter',
			},
			{
				name(){
					return this.$t("to_kwd") +
					this.$t("turn") +
					(this.$form?(this.$i18n.locale === 'zh-CN'?'':' ')+(this.$form.to_currency || ''):'')+
					this.$t("rate")
				},
				key: fields["to_rate_kwd"],
				component: "InputNumber",
				bind: {
					min: 0,
					step: 0.0001,
					style: "width:100%",
				},
				default: 0,
				placeholder: 'Please Enter',
			},
			{
				name(){
					return this.$t("to_bhd") +
					this.$t("turn") +
					(this.$form?(this.$i18n.locale === 'zh-CN'?'':' ')+(this.$form.to_currency || ''):'')+
					this.$t("rate")
				},
				key: fields["to_rate_bhd"],
				component: "InputNumber",
				bind: {
					min: 0,
					step: 0.0001,
					style: "width:100%",
				},
				default: 0,
				placeholder: 'Please Enter',
			},
			{
				name(){
					return this.$t("to_omr") +
					this.$t("turn") +
					(this.$form?(this.$i18n.locale === 'zh-CN'?'':' ')+(this.$form.to_currency || ''):'')+
					this.$t("rate")
				},
				key: fields["to_rate_omr"],
				component: "InputNumber",
				bind: {
					min: 0,
					step: 0.0001,
					style: "width:100%",
				},
				default: 0,
				placeholder: 'Please Enter',
			},
			{
				name(){
					return this.$t("to_ipd") +
					this.$t("turn") +
					(this.$form?(this.$i18n.locale === 'zh-CN'?'':' ')+(this.$form.to_currency || ''):'')+
					this.$t("rate")
				},
				key: fields["to_rate_ipd"],
				component: "InputNumber",
				bind: {
					min: 0,
					step: 0.0001,
					style: "width:100%",
				},
				default: 0,
				placeholder: 'Please Enter',
			},
			{
				name(){
					return this.$t("to_ils") +
					this.$t("turn") +
					(this.$form?(this.$i18n.locale === 'zh-CN'?'':' ')+(this.$form.to_currency || ''):'')+
					this.$t("rate")
				},
				key: fields["to_rate_ils"],
				component: "InputNumber",
				bind: {
					min: 0,
					step: 0.0001,
					style: "width:100%",
				},
				default: 0,
				placeholder: 'Please Enter',
			},
			{
				name(){
					return this.$t("to_jod") +
					this.$t("turn") +
					(this.$form?(this.$i18n.locale === 'zh-CN'?'':' ')+(this.$form.to_currency || ''):'')+
					this.$t("rate")
				},
				key: fields["to_rate_jod"],
				component: "InputNumber",
				bind: {
					min: 0,
					step: 0.0001,
					style: "width:100%",
				},
				default: 0,
				placeholder: 'Please Enter',
			},
			{
				name(){
					return this.$t("to_iqd") +
					this.$t("turn") +
					(this.$form?(this.$i18n.locale === 'zh-CN'?'':' ')+(this.$form.to_currency || ''):'')+
					this.$t("rate")
				},
				key: fields["to_rate_iqd"],
				component: "InputNumber",
				bind: {
					min: 0,
					step: 0.0001,
					style: "width:100%",
				},
				default: 0,
				placeholder: 'Please Enter',
			},
		],
	}
}